import './welcome.css'

const Introduction = () => {
    return (
        <div className='Introduction'>
            <p>An aspiring software and data engineer who is passionate about building impactful products.</p>
        </div>
    );
}

export default Introduction